import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_APIURL,
  withCredentials: false, // This is the default
});

// A plain object containing a File is NOT auto-encoded as multipart by axios
// (it gets JSON.stringify'd while still claiming a multipart Content-Type
// with no boundary, which the backend can't parse). Build a real FormData
// instead and let the browser set the Content-Type (with boundary) itself.
function toFormData(req) {
  const formData = new FormData();
  Object.entries(req).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    formData.append(key, value instanceof File ? value : String(value));
  });
  return formData;
}

export default{
    async requestCard(req){
        await apiClient.post('api/request-user', toFormData(req))

    },
    async requestPartner(req){
      await apiClient.post('api/partner/create', toFormData(req))

  },
}